import React from 'react';

const Profit = ({payout, wager}) => {
    let num = (wager.num * (payout.num - 1));
    let profit = parseFloat(num);
    return (
        <div>
            <span id="label"> ON WIN </span>
            <div>
                { profit.toString() }
            </div>
        </div>
    )
}

export default Profit;


// WEBPACK FOOTER //
// ./src/components/bet/Profit.js